import React, { useEffect, useState, useCallback } from 'react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function Table({ getTimeStreamData, showMap, height, deviceType }) {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = JSON.parse(localStorage.user).organization.id;
  const [{ isLoading, isError, data }, getData] = useApi();
  const [stats, setStats] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const formModel = {
    asset_type: '',
    device_type: '',
    project_name: '',
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const [state, projectData] = useApi();
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleDeviceTypeChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value === "BLE Tag" ? "BLE_TAG" : e.target.value === "Cellular Tag" ? "CATM1_TAG" : '', }));
  const [project, setProject] = useState([]);
  const day = 1000*60*60*24;

  useEffect(() => {
    getData(`/organization/${orgId}/assets`, 'GET');
    projectData(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProject(state.data.projects);
    }
  }, [state.isLoading, state.isError, state.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setStats(data.customerAsset);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }
    if (formData.asset_type === '' && formData.device_type === '' && formData.project_name === '') {
      setFilteredData(stats);
    }
    let z = stats;

    if (formData.project_name) {
      z = z.filter((x) => x?.project?.projectName === formData.project_name);
    }

    if (formData.device_type) {
      z = z.filter((x) => x?.device?.deviceType === formData.device_type);
    }

    if (formData.asset_type) {
      z = z.filter((x) => x?.trackedUnit?.tuType === formData.asset_type);
    }
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        return (
          x?.device?.id?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
          x?.trackedUnit?.trackingId?.toLowerCase().indexOf(normalizedQuery) >= 0
        );
      });
    }

    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [stats, formData]);

  const getDeviceId = (id) => {
    getTimeStreamData(id);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };


  return (
    <div className="relative h-36" style={{ background: 'rgb(249, 249, 249' }}>
      <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
        <div
          className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
          style={{ paddingTop: '4vh' }}
        >
          <span className="text-textBlue1 font-bold text-xl">Dashboard</span>
          <div className="block lg:flex mt-1 lg:mt-0 justify-center">
            <img src='./assets/img/Unit.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Unit</span>
            <img src='./assets/img/Box.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Box</span>
            <img src='./assets/img/Pallet.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Pallet</span>
            <img src='./assets/img/Container.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Container</span>
            <img src='./assets/img/BLE.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">BLE</span>
            <img src='./assets/img/CatM1.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Cellular</span>
            {/* <img src='./assets/img/Gateway.svg' className="h-8 ml-2 py-2" /><span className="py-1 px-3">Gateway</span> */}
          </div>
          <div className="block lg:flex mt-1 lg:mt-0">
            <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 rounded-sm ml-3 flex justify-between items-center rounded-md">
              <input
                type="text"
                placeholder="Search Asset ID"
                autoComplete="off"
                className="text-textBox bg-transparent focus:outline-none"
                value={formData.q}
                name="q"
                onChange={handleInputChange}
                style={{ borderColor: '#e6e6e6' }}
              />
              <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute z-50 w-full h-full" style={{ top: '5em' }}>
        <div className="bg-tableBg w-tableWidth m-auto mb-3">
          <div className="bg-tableHeader w-full flex" style={{ border: '1px solid #E6E6E6' }}>
            <div className="px-5 flex w-full">
              <div className="w-1/5 py-2 text-sm font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#648299"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    className="border-2 font-bold text-sm h-10
                     pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-200 focus:outline-none appearance-none rounded-xl"
                    value={formData.asset_type}
                    name="asset_type"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">ASSET TYPE</option>
                    <option>BOX</option>
                    <option>PALLET</option>
                    <option>CONTAINER</option>
                    <option>UNIT</option>
                  </select>
                </div>
              </div>
              <div className="w-1/5 py-4 pl-1 text-sm font-bold">ASSET ID</div>
              <div className="w-1/5 py-4 text-sm font-bold">DEVICE ID</div>
              <div className="w-1/5 py-2 text-sm font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#648299"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.device_type === "BLE_TAG" ? "BLE Tag" : formData.device_type === "CATM1_TAG" ? "Cellular Tag" : ""}
                    name="device_type"
                    className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                    onChange={handleDeviceTypeChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">DEVICE TYPE</option>
                    <option>BLE Tag</option>
                    <option>Cellular Tag</option>
                    {/* <option>BLE_TAG</option>
                    <option>CATM1_TAG</option>
                    <option>BLE_GW</option> */}
                  </select>
                </div>
              </div>
              <div className="w-1/5 py-2 text-sm font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#648299"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.project_name}
                    name="project_name"
                    className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option value="">PROJECT</option>
                    {project.map((item) => (
                      <option key={item?.id}>{item?.projectName}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-1/5 py-4 pl-1 text-sm font-bold">LAST MODIFIED</div>
            </div>
            <div className={`example bg-tableBg fixed h-${height ? 'tableHeightMap' : 'tableHeight'}`}>
              <div className="pb-1">
                {filteredData.map((item, idx) => {
                  var modified = getTimeoffset(item?.updatedAt);
                  // var modified = Math.round((Date.now() - new Date(item?.updatedAt).getTime()) / day) !== 0 ? `${Math.round((Date.now() - new Date(item?.updatedAt).getTime()) / day)} Days Ago` : `${parseInt(Math.abs(Date.now() - new Date(item?.updatedAt).getTime()) / 36e5)} Hours Ago`
                  // var modified = new Date(item?.updatedAt).getDay() === 0 ? `${new Date(item?.updatedAt).getHours()} Hours Ago` : `${new Date(item?.updatedAt).getDay()} Days Ago`;
                  var assetTypeIcon = item?.trackedUnit?.tuType !== null ? item?.trackedUnit?.tuType : '';
                  if ((item?.trackedUnit?.tuType) === "BOX") assetTypeIcon = <img src='./assets/img/Box.svg' width='12%' />
                  if ((item?.trackedUnit?.tuType) === "UNIT") assetTypeIcon = <img src='./assets/img/Unit.svg' width='9%' />
                  if ((item?.trackedUnit?.tuType) === "CONTAINER") assetTypeIcon = <img src='./assets/img/Container.svg' width='12%' />
                  if ((item?.trackedUnit?.tuType) === "PALLET") assetTypeIcon = <img src='./assets/img/Pallet.svg' width='12%' />
                  var deviceTypeIcon = item?.device?.deviceType !== null ? item?.device?.deviceType : '';
                  if ((item?.device?.deviceType) === "BLE_TAG") deviceTypeIcon = <img src='./assets/img/BLE.svg' width='12%' />
                  if ((item?.device?.deviceType) === "CATM1_TAG") deviceTypeIcon = <img src='./assets/img/CatM1.svg' width='12%' />
                  if ((item?.device?.deviceType) === "BLE_GW") deviceTypeIcon = <img src='./assets/img/Gateway.svg' width='12%' />
                  const orgInfo = {
                    type: assetTypeIcon,
                    code: item?.trackedUnit?.trackingId,
                    deviceId: item?.device?.id,
                    deviceType: deviceTypeIcon,
                    projectName: item?.project?.projectName,
                    lastModified: modified,
                  };
                  return (
                    <div
                      tabIndex={idx}
                      className="m-2.5 bg-white border-2 border-transparent flex rounded-md shadow-sm relative hover:border-indigo-200 focus-within:border-indigo-200"
                    >
                      <div
                        className="text-role w-1/5 py-4 text-sm flex pl-16"
                        onClick={() => {
                          showMap(false);
                        }}
                      >
                        {orgInfo.type}
                      </div>
                      <a
                        href="#"
                        className="w-1/5 py-4 text-sm md:no-underline md:hover:underline"
                        style={{ color: 'blue' }}
                        onClick={() => {
                          getDeviceId(item?.device?.id);
                          showMap(true);
                          deviceType(item?.trackedUnit?.trackingId, orgInfo.deviceId);
                        }}
                      >
                        {orgInfo.code}
                      </a>
                      <div
                        className="text-role w-1/5 py-4 text-sm"
                        onClick={() => {
                          showMap(false);
                        }}
                      >
                        {orgInfo.deviceId}
                      </div>
                      <div
                        className="text-role w-1/5 py-4 text-sm pl-14"
                        onClick={() => {
                          showMap(false);
                        }}
                      >
                        {orgInfo.deviceType}
                      </div>
                      <div
                        className="text-role w-1/5 py-4 text-sm"
                        onClick={() => {
                          showMap(false);
                        }}
                      >
                        {orgInfo.projectName}
                      </div>
                      <div
                        className="text-role w-1/5 py-4 text-sm"
                        onClick={() => {
                          showMap(false);
                        }}
                      >
                        {/* {orgInfo.lastModified !== null ? getTimeoffset() : 'N/A'} */}
                        {orgInfo.lastModified}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Table;
